import React, { useEffect, useState, useContext } from 'react';
import { Wrapper, Logo, StyledFormControl } from './Navigation.styles';
import logoImg from '../../../assets/images/Vee_center_logo_color.png';
import Menu from 'components/molecules/Menu/Menu';

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';

import { api } from '../../../api/api';
import { envName } from '../../../api/api';
import { GlobalContext } from '../../../context/GobalState';
import { useHistory } from 'react-router-dom';

import axios from 'axios';
const Header = ({ logout }) => {
  const { authToken, permissionLevel, skill, setSkill, campaign, setCampaign } = useContext(GlobalContext);
  const [skillList, setSkillList] = useState([]);
  const [campaignList, setCampaignList] = useState([]);
  const history = useHistory();

  const handleChange = (event) => {
    setSkill(event.target.value);
  };
  const handleCampChange = (event) => {
    setCampaign(event.target.value);
  };

  useEffect(() => {
    if (authToken) {
      axios
        .get(`${api}data/skill/`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then(({ data }) => {
          if (data.length === 0) {
            history.replace('/no-permission');
          }
          setSkillList(data);
          setSkill(data[0].bot_name);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    // eslint-disable-next-line
  }, [authToken]);
  useEffect(() => {
    if (authToken && skill) {
      axios
        .get(`${api}data/campaign/`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
          params: {
            skill: skill,
          },
        })
        .then(({ data }) => {
          setCampaignList(data);
          setCampaign(data[0].campaign_name);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    // eslint-disable-next-line
  }, [authToken, skill]);

  return (
    <Wrapper>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '70px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Logo>
            <img src={logoImg} alt="vee" />
          </Logo>
          <Box
            sx={{
              width: '1px',
              height: '30px',
              background: 'white',
              ml: 4,
            }}
          />
          <StyledFormControl size="small" sx={{ width: '100px', ml: 4 }}>
            <InputLabel id="demo-simple-select-label">Skill</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={skill}
              label="Skill"
              onChange={handleChange}
              sx={{ width: '120px' }}
              MenuProps={{
                style: { zIndex: 9001 },
              }}
            >
              {skillList?.map((option, index) => (
                <MenuItem key={index} value={option.bot_name}>
                  {option.bot_name}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
          <Box
            sx={{
              width: '1px',
              height: '30px',
              background: 'white',
              ml: 6,
            }}
          />
          <StyledFormControl size="small" sx={{ width: '100px', ml: 4 }}>
            <InputLabel id="demo-simple-select-label">Campaign</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={campaign}
              label="Campaign"
              onChange={handleCampChange}
              sx={{ width: '120px' }}
              MenuProps={{
                style: { zIndex: 9001 },
              }}
            >
              {campaignList?.map((option, index) => (
                <MenuItem key={index} value={option.campaign_name}>
                  {option.campaign_name}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
          <Box
            sx={{
              width: '1px',
              height: '30px',
              background: 'white',
              ml: 6,
            }}
          />
          <Typography variant="h6" sx={{ color: 'white', ml: 4 }}>
            {envName ? envName : 'ENV NOT SET'}
          </Typography>
        </Box>
      </Box>
      <Box>
        <Menu logout={logout} />
      </Box>
    </Wrapper>
  );
};

export default Header;
